import { EmailUpdater } from 'app/modules/UpdaterEmailForm/EmailUpdater';
import { PostFunction, httpClient } from 'pkg/httpClient/httpClient';

const EMAIL_UPDATER_URL = (quoteId: string) => `/quote/updateEmail?id=${quoteId}`;

interface EmailUpdaterApi {
  post: (data: EmailUpdaterParams) => Promise<EmailUpdater>;
}

export interface EmailUpdaterParams {
  emailUpdater: EmailUpdater;
  quoteId: string;
}

const emailUpdaterApiFactory = (client: { post: PostFunction }): EmailUpdaterApi => ({
  post: ({ quoteId, emailUpdater }) =>
    client.post<EmailUpdater>(EMAIL_UPDATER_URL(quoteId), emailUpdater).then(({ data }) => data),
});

const emailUpdaterApi = emailUpdaterApiFactory(httpClient);

export { emailUpdaterApi, emailUpdaterApiFactory };
